import React from "react";
import { SimpleTable } from "./../Home/Tables/simpleTable";

export const ImportantDates = () => { 
  // Table of important dates
  const col1 = [
    "Workshop/Tutorial Proposal",
    "Paper Submission Deadline",
    "Notification of Acceptance",
    "Camera Ready Paper Submission",
    "Conference Date",
  ];
  const col2 = [
    "June 15, 2023",
    "August 15, 2023",
    "September 25, 2023",
    "September 30, 2023",
    "November 08-10, 2023",
  ];

  return (
    <div className="container">
        <div className="heading">
        <h1>IMPORTANT DATES</h1>
      </div>
      <br />
    <SimpleTable  col1={col1} col2={col2} />
    <br />

    <hr className="hr-style" />
    </div>
  );
};
